import { ids } from "@icarros/theme-react";
import styled from "styled-components";
const { color, foundation_colors, spacing } = ids || {};
export const StyledLoadingIllustration = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: ${({ variant }) => {
    if (variant === "neutral")
        return foundation_colors.black_white.color_white;
    if (variant === "primary")
        return color.backgrounds.ids_color_bg_brand_primary;
    if (variant === "secondary")
        return color.backgrounds.ids_color_bg_brand_secondary;
    return color.backgrounds.ids_color_bg_brand_primary;
}};
`;
export const StyledImageWrapper = styled.div `
  margin-bottom: ${spacing.ids_spacing_4x};
  > div {
    border: 0 none;
  }
`;
export const StyledTitleWrapper = styled.div `
  margin-bottom: ${spacing.ids_spacing_2x};
`;
export const StyledBodyWrapper = styled.div `
  margin-bottom: ${spacing.ids_spacing_6x};
`;
//# sourceMappingURL=LoadingIllustration.style.js.map